export enum UrlNames {
  schedule ='schedule',
  workout = 'workout',
  chat = 'chat'
}
